// apps/spa/src/routes/CommandNew.tsx
// /commands/new — New slash command editor page (CMD-02).

import { Link } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { CommandEditorForm } from '@/components/commands/CommandEditorForm';

export function CommandNew() {
  return (
    <div className="space-y-4">
      <Link
        to="/commands"
        className="text-muted-foreground hover:text-foreground inline-flex items-center text-sm transition-colors"
      >
        <ChevronLeft className="size-4" />
        Back to commands
      </Link>
      <CommandEditorForm mode="new" />
    </div>
  );
}
